// React-Table-6 Tr Custom Component (ROW WRAPPER ONLY)

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import { lightBlue, orange, grey } from '@mui/material/colors';
import cx from 'classnames';

import { injectIntl } from 'react-intl';

import { Reorder as ReorderIcon, Lock as LockIcon } from '@mui/icons-material';

const RTTrCompStyle = (theme) => ({
	paper: {
		position: 'relative',
		width: '100%',
	},
	rowButtonDivLeft: {
		position: 'absolute',
		left: theme.spacing(2),
		[theme.breakpoints.down(theme.mobileViewBreakpoint)]: {
			left: 2,
		},
	},
	rowDisabled: {
		backgroundColor: grey[500],
		opacity: 0.5,
	},
});
class RTTrComp extends React.Component {
	constructor() {
		super();
		this.state = {
			trStyle: {
				background: null,
			},
			mouseEntered: false,
		};
	}

	onMouseEnter = () => this.setState({ mouseEntered: true });
	onMouseLeave = () => this.setState({ mouseEntered: false });

	render() {
		const {
			children,
			intl,
			isHeaderRow,
			className,
			style,
			classes,
			dragHandleProps,
			isDragging,
			disabled,
			customRowColor,
			isEditing,
			...rest
		} = this.props;

		const { mouseEntered } = this.state;

		// Detect header row
		const headerRow = isHeaderRow || (className || '').includes('-highlight');

		return (
			<Paper
				elevation={mouseEntered ? 2 : 0}
				className={cx('rt-tr', className, classes.paper, { [classes.rowDisabled]: disabled })}
				style={{
					...style,
					backgroundColor: headerRow
						? undefined
						: customRowColor
						? customRowColor // Apply custom color if customRowColor value exists
						: isEditing
						? 'lightgreen' // edit mode (green)
						: isDragging
						? orange[200] // dragging (orange)
						: mouseEntered
						? lightBlue[50] // hover
						: undefined,
					textAlign: headerRow ? 'left' : undefined,
				}}
				{...rest}
				onMouseEnter={this.onMouseEnter}
				onMouseLeave={this.onMouseLeave}
			>
				{children}

				{dragHandleProps && (
					<div className={classes.rowButtonDivLeft}>
						<div {...dragHandleProps}>
							<Tooltip
								title={intl.formatMessage({
									id: 'components.RTTrComp.DragToChangePosition',
								})}
							>
								{dragHandleProps.draggable ? (
									<ReorderIcon fontSize="small" color="action" />
								) : (
									<LockIcon />
								)}
							</Tooltip>
						</div>
					</div>
				)}
			</Paper>
		);
	}
}

RTTrComp.propTypes = {
	classes: PropTypes.object.isRequired,
	intl: PropTypes.any,
	children: PropTypes.node,
	className: PropTypes.string,
	style: PropTypes.object,
	isHeaderRow: PropTypes.bool,
	dragHandleProps: PropTypes.object,
	isDragging: PropTypes.bool,
	isEditing: PropTypes.bool,
	disabled: PropTypes.bool,
	customRowColor: PropTypes.string,
};

RTTrComp.defaultProps = {
	isHeaderRow: undefined,
	disabled: false,
	customRowColor: undefined,
};

export default injectIntl(withStyles(RTTrCompStyle)(RTTrComp));
